import { cartesianToCartographic, cartographicToCartesian } from 'ayvri-std/lib/ellipsoid';
import { Vec3 } from 'ayvri-std/lib/vector';
const kMaxTileLevel = 20;
export default class HeightSampling {
    onSceneLoad(globe) {
        this.globe = globe;
    }
    /**
     * Shift the position so it is more than offset above ground
     */
    enforceAboveGround(position, offset) {
        if (typeof offset === 'undefined') {
            offset = 10.0;
        }
        const posCart = cartesianToCartographic(position);
        // Sample the terrain at the highest possible resolution (same as rendered)
        const minHeight = this.globe.sampleHeight(posCart, kMaxTileLevel);
        // If a valid result is returned
        if (typeof minHeight !== 'undefined' && posCart.height < minHeight + offset) {
            // if (typeof minHeight !== 'undefined') {
            posCart.height = minHeight + offset;
            const correctedPos = cartographicToCartesian(posCart.latitude, posCart.longitude, posCart.height);
            position.copy(correctedPos);
            return true;
        }
        return false;
    }
    applyLineOfSight(target, eye, offset, steps) {
        if (steps <= 0) {
            return false;
        }
        const eyeCart = cartesianToCartographic(eye);
        const targetCart = cartesianToCartographic(target);
        let targetHeight = this.globe.sampleHeight(targetCart);
        if (typeof targetHeight === 'undefined') {
            return false;
        }
        // Cater for target in the air
        targetHeight = Math.max(targetHeight, targetCart.height);
        const dir = Vec3.subtract(eye, target, new Vec3());
        const l = dir.length();
        // The minimum gradient to be enforced
        let minGrad = -Infinity;
        // Allow for a tollerance around local features
        // Make it increase if you zoom out a lot
        const localIrregularityTollerance = Math.max(50, l * 0.1);
        // Compute start and end ray positions (skipping a small radius around the target)
        const rayStartCart = Vec3.add(target, Vec3.multiply(dir, localIrregularityTollerance / l, new Vec3()), new Vec3());
        const rayStart = cartesianToCartographic(rayStartCart);
        const rayLength = l - localIrregularityTollerance;
        // Sample points along our ray
        const sampleHeights = this.globe.sampleHeights(rayStart, eyeCart, steps);
        // Walk from target to camera
        for (let i = 0; i < steps; ++i) {
            const t = i / (steps - 1);
            const targetDist = t * rayLength + localIrregularityTollerance;
            let sampleHeight = sampleHeights[i];
            if (typeof sampleHeight !== 'undefined') {
                // Apply offset
                sampleHeight += t * offset;
                const sampleGrad = (sampleHeight - targetHeight) / targetDist;
                if (sampleGrad > minGrad) {
                    minGrad = sampleGrad;
                }
            }
        }
        const incomingGrad = (eyeCart.height - targetHeight) / l;
        if (minGrad > incomingGrad) {
            eyeCart.height = targetHeight + minGrad * l;
            // Modify eye in place
            cartographicToCartesian(eyeCart.latitude, eyeCart.longitude, eyeCart.height, eye);
            // Indicate the valiue has changed
            return true;
        }
        return false;
    }
}
